<script>
export default {
  props: ['field', 'save'],
  data () {
    return {
      debounceSave: this.$lo.debounce(this.saveNotifyed, 1000),
      saving: false
    }
  },
  methods: {
    async saveNotifyed (field, value) {
      return this.save(field, value).finally(() => { this.saving = false })
    },
    update ({ value, debounced }) {
      this.saving = true
      if (debounced) {
        this.debounceSave(this.field, value)
      } else {
        this.debounceSave.cancel()
        this.saveNotifyed(this.field, value)
      }
    }
  },
  render (createElement) {
    if (this.field) {
      return this.$scopedSlots.default({
        update: this.update,
        saving: this.saving,
        field: this.field
      })
    } else {
      // TODO: может вернуть null?
      return null
    }
  }
}
</script>
